import React from 'react';
import { classNames } from '@utils';
import { getCurrentThemeConfig } from '@app/core/theme-config';

export interface ContentBoxContainerProps {
  className?: string;
}

/** Applies just the width of the content box. Used by the child if they are using in conjunction of 'applyContainerWidthToHeaderOnly' */
export const ContentBoxContainer: React.FC<ContentBoxContainerProps> = (props) => {
  const containerWidthClassNames = getCurrentThemeConfig().contentBoxContainer;

  return (
    <div className={classNames([containerWidthClassNames, props.className])}>{props.children}</div>
  );
};
